<h2 mat-dialog-title>Resultaten controlepunten en werkoverdracht</h2>
<mat-dialog-content>
    <table class="table">
        <tr>
            <th>Gebruiker</th>
            <th>Anwoorden</th>
        </tr>
        @for (result of results; track result) {
            <tr>
                <td>
                    {{ result.user.name }}
                </td>
                <td>
                    <div class="d-flex">
                        @if (result.controlepunten?.length) {
                            <a class="me-1 curpoint" (click)="showAnswers('controlepunten', result.controlepunten)">
                                Controlepunten
                            </a>
                        }
                        @if (result.werkoverdracht?.length) {
                            <a class="curpoint" (click)="showAnswers('werkoverdracht', result.werkoverdracht)">
                                Werkoverdracht
                            </a>
                        }
                    </div>
                </td>
            </tr>
        }
    </table>
</mat-dialog-content>
<mat-dialog-actions>
    <button class="planning-button cancel w-100" mat-raised-button mat-dialog-close="">Sluiten</button>
</mat-dialog-actions>
